/* eslint-disable react/prop-types */
/* eslint-disable prefer-regex-literals */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCommonInits } from 'hooks/useCommonInits';
import {
    getAssets,
    getGroupsbyId,
    getGroups,
    clearDataSource,
} from 'redux/datasource/dataSourceSlice';
import './createModal.css';
import {
    getAllAssets,
    saveGroupsAssets,
    updateGroup,
} from 'redux/datasource/dataSourceActions';
import { updatePanelContent } from 'redux/panels/panelsSlice';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import {
    Button,
    Grid,
    Typography,
    Checkbox,
    Box,
    FormControl,
    TextField,
    OutlinedInput,
    MenuItem,
    Select,
    InputLabel,
} from '@mui/material';
import { getUnitIds } from 'redux/auth/authSlice';

export default function CreateModal({
    isOpen,
    handleCloseModal,
    handleEdited,
}) {
    // eslint-disable-next-line no-unused-vars
    const [open, setOpen] = useState(false);
    const { dispatch, select } = useCommonInits();
    const unitsIDs = select(getUnitIds);
    const Assets = select(getAssets);
    const Groups = useSelector(getGroups);
    const [asset, setAssets] = useState([]);
    const [groupId, setGroupId] = useState('');
    const [error, setError] = useState({});
    const [errorMsg, setErrMsg] = useState(false);
    const [errorExecMsg, setExecErrMsg] = useState(false);

    const [errorAuthMsg, setAuthErrMsg] = useState(false);
    const [descErrMsg, setDescErrMsg] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [toggleButton, setToggleButton] = useState(false);
    const GroupByID = useSelector(getGroupsbyId);
    const [description, setDescription] = useState('');
    const [toAuth, setToAuth] = useState([]);
    const [toExec, setToExec] = useState([]);
    const groupRegex = new RegExp('^[1-9a-zA-Z][0-9a-zA-Z_]*$');
    // const emailRegex = new RegExp('^[1-9a-zA-Z][0-9a-zA-Z_.@]*$');
    const emailRegex = /^[\w-]+(?:\.[\w-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7}(?:\s*,\s*[\w-]+(?:\.[\w-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7})*$/;
    const id = useParams();
    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 2;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: '25%',
            },
        },
        getcontentanchorel: null,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
        },
        variant: 'menu',
    };
    const isGroupValid =
        groupName && groupName?.length <= 30 && groupRegex.test(groupName);
    const isAuthValid =
     !toAuth?.length || ( emailRegex.test(toAuth) && toAuth.length <= 200)
    const isExecValid =
    !toExec?.length ||  ( emailRegex.test(toExec) && toExec.length <= 200);
    const isDescValid = description?.length <= 100 && !(/^[=+\-@*%#$&()<>^]/.test(description));
    useEffect(() => {
        if (Assets) {
            const params = {
                filter: { EQUIP_TYPE: ['APCM'] },
                unit_id: unitsIDs,
            };
            dispatch(getAllAssets(params));
        }
        if (Groups) {
            handleEdited;
            setGroupId(id);
        }
        if (GroupByID) {
            setGroupId(GroupByID._id);
            setGroupName(GroupByID.name);
            setDescription(GroupByID.desc);
            if (GroupByID?.authorizer_email)
                setToAuth(GroupByID?.authorizer_email);
            if (GroupByID?.executor_email) setToExec(GroupByID?.executor_email);
            if (GroupByID?.assets) setAssets(GroupByID?.assets);
            if (GroupByID?.name) setToggleButton(true);
        }
    }, [GroupByID]);

    const handleDataChange = () => {
        dispatch(
            updatePanelContent({
                groupName,
                description,
                asset,
                toAuth,
                toExec,
            }),
        );
        if (isGroupValid) {
            setErrMsg(false);
        }
        if (isDescValid) {
            setDescErrMsg(false);
        }
        if (isExecValid) {
            setExecErrMsg(false);
        }
        if (isAuthValid) {
            setAuthErrMsg(false);
        }
    };

    const onAssetSelect = event => {
        const {
            target: { value },
        } = event;
        setAssets(typeof value === 'string' ? value.split(',') : value);
    };

    const onExecSelect = event => {
        const {
            target: { value },
        } = event;
        setToExec(typeof value === 'string' ? value.split(',') : value);
    };

    const onAuthSelect = event => {
        const {
            target: { value },
        } = event;
        setToAuth(typeof value === 'string' ? value.split(',') : value);
    };

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    const handleClose = () => {
        handleCloseModal();
        dispatch(clearDataSource());
    };

    const saveGroup = () => {
        setError({
            groupName: !groupName?.length > 30 || !groupName?.length,
            asset: !asset?.length,
        });

        if (
            isGroupValid &&
            asset?.length &&
           isDescValid &&
            isExecValid &&
            isAuthValid
        ) {
            const params = {
                desc: description,
                name: groupName,
                assets: asset,
                authorizer_email: toAuth,
                executor_email: toExec,
            };
            dispatch(saveGroupsAssets(params));
            handleDataChange();
            handleCloseModal();
        } else {
            if (!isGroupValid) {
                setErrMsg(true);
            }
            if (!isDescValid) {
                setDescErrMsg(true);
            }
            if (!isExecValid) {
                setExecErrMsg(true);
            }
            if (!isAuthValid) {
                setAuthErrMsg(true);
            }
        }
    };

    const updateGroups = () => {
        setError({
            groupName: !groupName.length > 30 || !groupName.length,
            asset: !asset?.length,
        });
        if ( isGroupValid &&
            asset?.length &&
            isDescValid &&
            isExecValid &&
            isAuthValid) {
            const params = {
                desc: description,
                name: groupName,
                _id: groupId,
                assets: asset,
                authorizer_email: toAuth,
                executor_email: toExec,
            };
            dispatch(updateGroup(params));
            handleClose();
        } else {
            if (!isGroupValid) {
                setErrMsg(true);
            }
            if (!isDescValid) {
                setDescErrMsg(true);
            }
            if (!isExecValid) {
                setExecErrMsg(true);
            }
            if (!isAuthValid) {
                setAuthErrMsg(true);
            }
        }
    };

    const renderGroup = () => (
            <div>
                <TextField
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={groupName || ''}
                    error={error.groupName}
                    inputProps={{
                        maxLength: 31,
                    }}
                    sx={{ marginTop: 2, marginBottom: 2 }}
                    label='Group Name'
                    onChange={e => setGroupName(e.target.value)}
                    onBlur={handleDataChange}
                />
                {errorMsg ? (
                    <label style={{ color: 'red', marginBottom: 5 }}>
                        Enter valid format & you can enter only upto 30
                        characters
                    </label>
                ) : null}

                <FormControl sx={{ width: 470, marginRight: 2, padding: 0.5 }}>
                    <InputLabel id="demo-multiple-name-label">
                        Assets
                    </InputLabel>
                    <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={asset || []}
                        error={error.asset}
                        onChange={onAssetSelect}
                        input={<OutlinedInput label="Assets" />}
                        MenuProps={MenuProps}
                        renderValue={selected => selected.join(', ')}
                        sx={{ height: 40 }}
                    >
                        {Assets?.map(item => (
                            <MenuItem
                                key={item._id}
                                value={item.asset_id}
                                disabled={Groups.some(obj =>
                                    obj.assets.includes(item?.asset_id),
                                )}
                            >
                                <Checkbox
                                    checked={asset.indexOf(item.asset_id) > -1}
                                />
                                {item.asset_id}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={description || ''}
                    sx={{ marginTop: 2, marginBottom: 2 }}
                    label='Description'
                    inputProps={{
                        maxLength: 101,
                    }}
                    onChange={e => setDescription(e.target.value)}
                    onBlur={handleDataChange}
                />
                {descErrMsg && (
                    <span style={{ color: 'red', marginTop: '-20px' }}>
                        Enter valid description & You can enter only upto 100 characters
                    </span>
                )}
                <TextField
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={toExec || []}
                    sx={{ marginTop: 2, marginBottom: 2 }}
                    label={"Executor's Email"}
                    onChange={onExecSelect}
                    inputProps={{ maxLength: 201 }}
                />
                {errorExecMsg ? (
                    <label style={{ color: 'red', marginBottom: 5 }}>
                      Enter valid email format & You can enter only upto 200 characters
                    </label>
                ) : null}
                <TextField
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={toAuth || []}
                    sx={{ marginTop: 2, marginBottom: 2 }}
                    label={"Authorizer's Email"}
                    onChange={onAuthSelect}
                    inputProps={{ maxLength: 201 }}
                />
                {errorAuthMsg ? (
                    <label style={{ color: 'red', marginBottom: 5 }}>
                        Enter valid email format & You can enter only upto 200 characters
                    </label>
                ) : null}
            </div>
        );

    return (
        <div>
            <Box sx={style}>
                <Grid container>
                    <Grid item xs={10}>
                        {toggleButton === true ? (
                            <Typography
                                id="spring-modal-title"
                                variant="h6"
                                component="h2"
                            >
                                {toggleButton === true} Edit Group
                            </Typography>
                        ) : (
                            <Typography
                                id="spring-modal-title"
                                variant="h6"
                                component="h2"
                            >
                                Create Group
                            </Typography>
                        )}
                    </Grid>
                    <Grid
                        item
                        sx={{
                            position: 'absolute',
                            right: '5px',
                            top: '5px',
                        }}
                    >
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
                {renderGroup()}
                <Grid item sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="outlined"
                        sx={{ mt: 2, mr: 2 }}
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    {toggleButton === true ? (
                        <Button
                            variant="outlined"
                            sx={{ mt: 2, mr: 2 }}
                            onClick={updateGroups}
                        >
                            Update
                        </Button>
                    ) : (
                        <Button
                            variant="outlined"
                            sx={{ mt: 2, mr: 2 }}
                            onClick={saveGroup}
                        >
                            Create
                        </Button>
                    )}
                </Grid>
            </Box>
        </div>
    );
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.default',
    border: '1px solid',
    boxShadow: 24,
    p: 2,

    errMsg: {
        color: 'red',
    },

    errMsg1: {
        backgroundColor: 'red',
    },
};
